import React from 'react';
import Mission from '../components/Mission';


const MissionPage = () => {
  return (
    <div>
      <Mission />
    </div>
  );
};

export default MissionPage;


